export type RGBAData = {
    red: number,
    green: number,
    blue: number,
    alpha: number
}
export default function RGBAFromData(data: RGBAData): string {
    return `rgba(${data.red},${data.green},${data.blue},${data.alpha})`
}